// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table th[data-v-19a085c5]{border-top:none}.card-body[data-v-19a085c5]{padding:.5em}", ""]);
// Exports
module.exports = exports;
